import { SortingDirection } from '@doxyme/ui';
import { store } from '../../../../../../store/store';
import { sortingData } from '../selectors';
export const calculateDirection = (column) => {
    const state = store.getState();
    const { field, direction } = sortingData(state);
    return field === column ? direction : SortingDirection.NONE;
};
